Vendd.Scripts.load(function () {
    var $pl = $('.x-product-list');

    if ($pl.length < 1) return;

    var $selectedRelatedPl;

    var lazyLoadPrices = $('.list-lazy-load-prices', $pl).first().text().toLowerCase().trim() === "true";
    var customPrices = false;

    var $mainPL = $('.x-main-product-list .x-product-list');
    var hasInfiniteScroll = $mainPL.data('scrolled') === true;
    var hasScrollId = sessionStorage.getItem('scrollToProductId') ? true : false;

    $pl.each(function () {
        var $wrapper = $(this),
            wrapper = $wrapper.get(0),
            $configuration, configuration, jsonConfiguration,
            $resultsFancyboxLink = $('.results-fancybox-link', $wrapper), $resultsWraper = $('.js-results-wrapper', $wrapper),
            isScrolled = $wrapper.data('scrolled') === true,
            hasQuickbuy = $wrapper.data('quickbuy') === true,
            hasColorSelector = $wrapper.data('colorselector') === true,
            forwardUpdates = 0,
            forwardUpdatesCup = 2,
            backwardUpdates = 0,
            backwardUpdatesCup = 0;

        var model = {}, pagerModel = {};

        if ($resultsFancyboxLink.length > 0) {
            $resultsFancyboxLink.fancybox({ type: 'inline' });
        }

        $configuration = $('.configuration', $wrapper);

        configuration = $configuration.text();

        if (configuration)
            jsonConfiguration = JSON.parse(configuration);

        //$configuration.remove();

        wrapper.getConfiguration = function () { return configuration; };

        $('.wrapper-to-delete').remove();

        if (hasQuickbuy) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetCurrentPage(wrapper, configuration, 'productList'));
        }

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl(wrapper));

        var loading = false, hasNext = true, hasPrevious = true, initialCall = true;

        wrapper.loading = function (option, direction) {
            loading = option;
            if (option === true) {
                $('.scrolllist-pager-notification[data-direction="' + direction + '"]').addClass('disabled');
                $('.scrolllist-pager-notification[data-direction="' + direction + '"]').addClass('x-loading');
            } else {
                if (direction === 'forward') {
                    if (forwardUpdates >= forwardUpdatesCup) {
                        $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
                        $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled x-loading');
                    }
                }
                else if (direction === 'backward') {
                    if (backwardUpdates >= backwardUpdatesCup) {
                        $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
                        $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled x-loading');
                    }
                } else {
                    $('.scrolllist-pager-notification').removeClass('disabled x-loading');
                }
            }
        };

        wrapper.onSuccess = function (envelope) {

            if (envelope.message.data.list !== wrapper) return;
            
            var direction = '';

            model = envelope.message.data.model;

            if (model.Items.length === 0) {

                if (envelope.message.data.position == 'BottomOfList') {
                    hasNext = false;
                    direction = 'forward';
                }
                if (envelope.message.data.position == 'TopOfList') {
                    hasPrevious = false;
                    direction = 'backward';
                }
                if (envelope.message.data.position != 'Reload') {
                    wrapper.loading(false, direction);
                    return;
                }
            }

            if (model.HasQuickBuy && model.Items.length > 0) {
                Vendd.Quickbuy.addToQuickbuyList(model.Items[0], true);
            }

            var html = Vendd.Handlebars.parse("productList_A", model);

            var $html = $(html),
                $list = $('> ul', $wrapper),
                $boxes,
                items, lastItem, grouping, rowSize;

            configuration = $('.configuration', $html).text();

            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($html));

            $boxes = $('.x-product-box', $html);

            lastItem = $list.children().last();
            grouping = $html.data('grouping');
            rowSize = 3;

            items = wrapBoxes($boxes, grouping, rowSize, lastItem, model);
            if (envelope.message.data.position == 'BottomOfList') {
                if (parseInt($wrapper.attr('data-total-pages')) == model.PageNumber) {
                    $('.scrolllist-pager-notification[data-direction="forward"]').addClass('hidden');
                    $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
                } else {
                    $('.scrolllist-pager-notification[data-direction="forward"] .current-page').html(model.PageNumber);
                }

                var indicator = $('.page-indicator', $wrapper).eq(0).clone();
                indicator.attr('data-page', model.PageNumber);
                $('.page-number', indicator).html(model.PageNumber);
                $list.append(indicator);
                $list.append(items);
                $('.page-indicator', $wrapper).removeClass('hidden');
                direction = 'forward';
            }

            if (envelope.message.data.position == 'TopOfList') {
                if (model.PageNumber == 1) {
                    $('.scrolllist-pager-notification[data-direction="backward"]').addClass('hidden');
                    $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
                } else {
                    $('.scrolllist-pager-notification[data-direction="backward"] .current-page').html(model.PageNumber);
                }
                var elementFocused = $(' >ul >li', $wrapper).eq(0),
                    initPos = elementFocused.parent().offset().top, latePos,
                    windowPos = $(window).scrollTop(),
                    indicator = $('.page-indicator', $wrapper).eq(0).clone();

                indicator.attr('data-page', model.PageNumber);
                $('.page-number', indicator).html(model.PageNumber);
                $list.prepend(items);
                $list.prepend(indicator);
                $('.page-indicator', $wrapper).removeClass('hidden');
                latePos = elementFocused.offset().top;
                $('html,body').scrollTop(windowPos + latePos - initPos);

                direction = 'backward';
            }

            if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {
                $("img[data-lazyload]", $wrapper).lazyload({
                    effect: 'fadeIn',
                    threshold: 500,
                    skip_invisible: false
                }).removeAttr("data-lazyload");
            }

            if (model.Items[0][0].AlreadyInCartEnabled) {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());
            }
            if (model.Items[0][0].AlreadyInWishlistEnabled) {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel());
            }
            if (model.Items[0][0].AlreadyInCompareListEnabled) {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
            }

            if (lazyLoadPrices || customPrices) {
                var productItems = [];
                $boxes.each(function (i, el) {
                    productItems.push(parseInt($(el).attr('data-variantid')));
                });

                var dataObj = {
                    itemIds: productItems,
                    fetchPrices: true,
                    fetchAvailabilities: true,
                    fetchStock: true
                };
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(dataObj));
            }

            if (hasColorSelector) {
                $boxes.each(function (box, i) {
                    var $box = $(this);
                    var selectedColorId = $('.js-color-selector.selected', $box).data('id');
                    $box.attr('data-selected-colorid', selectedColorId);

                    addSkuParameterInProductBox($box, selectedColorId);
                });
            } 

            wrapper.loading(false, direction);
        };

        wrapper.onFailure = function (envelope) {
            if (envelope.message.data.list !== wrapper)
                return;

            var direction = '';

            if (envelope.message.data.position == 'BottomOfList') {
                direction = 'forward';
            }
            if (envelope.message.data.position == 'TopOfList') {
                direction = 'backward';
            }
            wrapper.loading(false, direction);
        };

        wrapper.onFailureCurrent = function (envelope) {
            _LTracker.push({
                "Message Error": {
                    "message": "Quickbuy couldn't be initialized, in Product list",
                    "publisher": "Vendd.ScrollList.Messages.GetCurrentPageFailure"
                }
            });
        };

        wrapper.onSuccessCurrent = function (envelope) {

            if (envelope.message.data.list.list != wrapper) return;

            var model = envelope.message.data.model;  

            Vendd.Quickbuy.addToQuickbuyList(model);
            $wrapper.removeClass('quickbuy-loading');

            if (hasColorSelector) {
                var $boxes = $('.x-product-box', wrapper);
                $boxes.each(function (box, i) {
                    var $box = $(this);
                    var selectedColorId = $('.js-color-selector.selected', $box).data('id');
                    $box.attr('data-selected-colorid', selectedColorId);

                    addSkuParameterInProductBox($box, selectedColorId);
                });
            } 
        };

        wrapper.updatePageUrl = function () {

            if ($wrapper.hasClass('js-redirecting'))
                return;

            var element = Array.from($('>ul>li[data-page]', $wrapper)).filter(function (element) { return $(window).scrollTop() <= $(element).offset().top; })[0],
                pageNumber = $(element).length ? $(element).data('page') : $('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).data('page'),
                pager = $('.x-pager[data-page-count]'),
                pageCount = pager.length ? (parseInt(pager.attr('data-page-count')) || 0) : 0,
                comboPagers = $('.pager .x-pager-combopages');

            comboPagers.each(function (index, comboPager) {
                var $comboPager = $(comboPager);
                $('select', $comboPager).addClass('disabled');
                $('.newList>li a', $('select', $comboPager).siblings('.newListSelected')).eq(pageNumber - 1).trigger('click');
                $('select', $comboPager).removeClass('disabled');
            });

            if (history.replaceState) {

                var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
                    pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

                if (!(/\/P\d+\//i.test(querystring))) {
                    querystring = querystring + pageText;
                } else {
                    querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
                }

                var stateObject = {};
                var url = window.location.protocol
                    + "//"
                    + window.location.host
                    + querystring
                    + window.location.search;

                if (window.location.href !== url) {
                    var prev = $("head link[rel=prev]");
                    var next = $("head link[rel=next]");
                    var prevLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber - 1) + "$2");
                    var nextLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber + 1) + "$2");
                    if (prev) {
                        if (pageNumber > 1) {
                            prev.attr("href", prevLink);
                        } else {
                            prev.remove();
                        }
                    } else if (pageNumber > 1) {
                        $("head").append("link rel=\"prev\" href=\"" + prevLink + "\" />");
                    }
                    if (next) {
                        if (pageNumber < pageCount) {
                            next.attr("href", nextLink);
                        } else {
                            next.remove();
                        }
                    } else if (pageNumber < pageCount) {
                        $("head").append("link rel=\"next\" href=\"" + nextLink + "\" />");
                    }
                    history.replaceState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
                    //history.pushState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
                }
            }
        };

        wrapper.update = function (dataListMovement) {

            if (loading) return;

            if (dataListMovement == 'forward') {
                hasNext = parseInt($wrapper.attr('data-total-pages')) > parseInt($('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).attr('data-page'));
                if (!hasNext) return;
            }
            if (dataListMovement == 'backward') {
                hasPrevious = parseInt($('>ul>li[data-page]', $wrapper).eq(0).attr('data-page')) > 1;
                if (!hasPrevious) return;
            }

            wrapper.loading(true, dataListMovement);

            if (dataListMovement == 'forward') {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetNextPage(wrapper, configuration, 'productList'));
            }
            if (dataListMovement == 'backward') {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetPreviousPage(wrapper, configuration, 'productList'));
            }

        };

        wrapper.updatePlOnFiltersChange = function (envelope) {

            if (envelope.message.data.list !== wrapper) return;

            model = envelope.message.data.data.Products;
            pagerModel = envelope.message.data.data.Pager;

            //init variables for scroll
            forwardUpdates = 0, forwardUpdatesCup = 2, backwardUpdates = 0, backwardUpdatesCup = 0;

            //parse new product list
            var html = Vendd.Handlebars.parse("productListInner_A", model);
            $wrapper.html(html);

            //updates
            updatePageScroll();
            updatePagerAttr($wrapper, model, pagerModel);
            wrapper.updatePageUrl();

            //bind product list
            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

            if (model.Items.length > 0) {
                if (model.HasQuickBuy) {
                    Vendd.Quickbuy.addToQuickbuyList(model.Items[0], true);
                }
                if (model.Items[0][0].AlreadyInCartEnabled) {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());
                }
                if (model.Items[0][0].AlreadyInWishlistEnabled) {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel());
                }
                if (model.Items[0][0].AlreadyInCompareListEnabled) {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetWidgetModel());
                }
            }

            //hide pager if there are no products
            if (model.Items.length < 1) {
                $wrapper.closest('.x-main-product-list').siblings('.pager').addClass('hidden');
            } else {
                $wrapper.closest('.x-main-product-list').siblings('.pager').removeClass('hidden');
            }

            if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {
                $("img[data-lazyload]", $wrapper).lazyload({
                    effect: 'fadeIn',
                    threshold: 500,
                    skip_invisible: false
                }).removeAttr("data-lazyload");
            }

            var $boxes = $('.x-product-box', $wrapper);

            if (lazyLoadPrices || customPrices) {
                var productItems = [];
                $boxes.each(function (i, el) {
                    productItems.push(parseInt($(el).attr('data-variantid')));
                });

                var dataObj = {
                    itemIds: productItems,
                    fetchPrices: true,
                    fetchAvailabilities: true,
                    fetchStock: true
                };
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(dataObj));
            }

            if (hasColorSelector) {
                $boxes.each(function (box, i) {
                    var $box = $(this);
                    var selectedColorId = $('.js-color-selector.selected', $box).data('id');
                    $box.attr('data-selected-colorid', selectedColorId);

                    addSkuParameterInProductBox($box, selectedColorId);
                });
            } 
        };

        $wrapper.on('click', '.x-replaced-by-products .js-toggle', function (e) {
            var $container = $(this).closest('.x-replaced-by-products');

            $(this).toggleClass('icon-plus icon-minus');
            $container.find('.js-content').toggle();

            if (!$container.hasClass('initiliazed')) {
                initializeReplacedPL($container);
            }

        });

        $wrapper.on('click', '.js-select', function (e) {

            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            } else {
                $(this).addClass('selected');
            }

            updateButtonStatus();
        });

        $wrapper.on('click', '.js-add-selected', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $boxes = $('.x-product-box', $wrapper);

            if ($boxes.length < 1) {
                $this.attr('disabled', 'disabled').addClass('disabled');
                return;
            }

            var data = [], prObj;

            $boxes.each(function (i, el) {
                var $el = $(el);

                if ($el.find('.js-select').hasClass('selected')) {

                    prObj = {
                        id: $el.data('productid'),
                        skuId: $el.data('variantid'),
                        path: $el.data('path'),
                        qty: 1
                    };

                    data.push(prObj);
                }
            });

            if (data.length > 0) {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.MultipleAdd(data));
            }
        });

        if (isScrolled === true) {
            $(window).scroll($.debounce(300, function () {
                if (($(window).scrollTop() == 0 || $wrapper.offset().top > $(window).scrollTop()) && backwardUpdates < backwardUpdatesCup) {
                    backwardUpdates++;
                    wrapper.update('backward');
                }
                if (($(window).scrollTop() >= $(document).height() - $(window).height() - $('.footer-region').height() - 500 || isElementInViewport($('.scrolllist-pager-notification[data-direction="forward"]'))) && forwardUpdates < forwardUpdatesCup) {
                    forwardUpdates++;
                    wrapper.update('forward');
                }
                if ($(window).scrollTop() >= 0 && !loading) {
                    wrapper.updatePageUrl();
                }
            }));
        }

        //click in order to see more products
        $('.scrolllist-pager-notification').on('click', '.js-show', function () {
            if (!$(this).closest('.scrolllist-pager-notification').hasClass('disabled')) {
                if ($(this).data('direction') === 'forward') forwardUpdates = 0;
                else if ($(this).data('direction') === 'backward') backwardUpdates = 0;
                wrapper.update($(this).data('direction'));
            }
        });

        function initializeReplacedPL($container) {
            $selectedRelatedPl = $container.find('.x-replaced-product-list');

            $selectedRelatedPl.parent().addClass('x-loading');

            var plData = {
                itemId: $selectedRelatedPl.data('product-id'),
                itemPath: jsonConfiguration ? jsonConfiguration.ItemPath : '',
                pageNumber: $selectedRelatedPl.data('page-number'),
                pageSize: $selectedRelatedPl.data('page-size'),
                sortKey: jsonConfiguration ? jsonConfiguration.SortKey : '',
                fullPath: LhApp.Context.Item.FullPath,
                includeFilters: false,
                defaultUriFilter: "",
                templateCode: 'productList',
                configCode: "",
                excludeItemIds: jsonConfiguration ? jsonConfiguration.ExcludeItemIds : '',
                relationshipTypeName: $selectedRelatedPl.data('rel-type'),
                xRelatedProducts: $selectedRelatedPl.data('max-products'),
                EnableNoImage: $selectedRelatedPl.data('no-image'),
                isLazyLoadEnabled: $selectedRelatedPl.data('lazy-load'),
                imageTypeCodeArray: $selectedRelatedPl.data('image-type'),
            };
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetReplacedByProducts(plData));
        }

        function handleMulitpleAddResult(data) {
            var html = Vendd.Handlebars.parse(Handlebars.partials.multipleAddResults_A, JSON.parse(data));

            $resultsWraper.html(html);
            $resultsFancyboxLink.trigger('click');
        }

        function updateButtonStatus(e) {
            var isChecked = false;

            var $boxes = $('.x-product-box', $wrapper);

            $boxes.each(function (i, el) {
                var $el = $(el);
                if ($el.find('.js-select').hasClass('selected')) {
                    $('.js-add-selected', $wrapper).removeAttr('disabled').removeClass('disabled');
                    isChecked = true;
                    return;
                }
            });

            if (isChecked) return;

            $('.js-add-selected', $wrapper).attr('disabled', 'disabled').addClass('disabled');
        }

        function wrapBoxes($boxes, grouping, rowSize, lastItem, model) {
            var items = [],
                currentIndex, cssClass;

            lastItem.removeClass('last');

            currentIndex = lastItem.data('index') + 1;

            for (var i = 0; i < $boxes.length; i++) {
                var li = $('<li>');

                cssClass = "item" + currentIndex;
                cssClass += (currentIndex % 2) ? " odd" : " even";
                cssClass += (i === $boxes.length - 1) ? " last" : "";
                cssClass += currentIndex % rowSize === 0 ? " row-first" : "";
                cssClass += (currentIndex + 1) % rowSize === 0 ? " row-last" : "";

                li.append($boxes.eq(i))
                    .addClass(cssClass)
                    .attr('data-index', currentIndex)
                    .attr('data-page', model.PageNumber);

                items.push(li);

                currentIndex++;
            }

            return items;
        }

        function updatePagerAttr(wrapper, model, pagerModel) {
            //update products count
            $('.js-num-of-products').text(model.ItemsCountText);

            //update product list attributes
            wrapper.attr('data-previous-page', pagerModel.PrevPageNumber);
            wrapper.attr('data-next-page', pagerModel.NextPageNumber);
            wrapper.attr('data-total-pages', pagerModel.PagesCount);
            wrapper.attr('data-page-size', pagerModel.PagesSize);
            wrapper.attr('data-current-page', pagerModel.PagesNumber);

            //update list items attributes
            $('ul.items-list > li ', wrapper).attr('data-page', pagerModel.PagesNumber);

            //update page indicator
            if (wrapper.data('scrolled') === true) {
                $('ul.items-list', wrapper).prepend('<li class="page-indicator hidden" data-page="' + pagerModel.PagesNumber + '"><h3 class="page-text">' + pagerModel.PageText + ' <span class="page-number">' + pagerModel.PagesNumber + '</span> <span class="page-count">' + pagerModel.ItemsOfText + ' ' + pagerModel.PagesCount + '</span></h3></li>');
            }

            //update pager
            pagerModel.PagesCount > 1 ? $('.pager .x-pager').removeClass('hidden') : $('.pager .x-pager').addClass('hidden');

            //update scrollist pager
            if (parseInt($wrapper.attr('data-total-pages')) == pagerModel.PagesNumber) {
                $('.scrolllist-pager-notification[data-direction="forward"]').addClass('hidden');
            } else {
                $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('hidden disabled');
                $('.scrolllist-pager-notification[data-direction="forward"]').addClass('x-loading');
            }
            if (pagerModel.IsFirstPage) {
                $('.scrolllist-pager-notification[data-direction="backward"]').addClass('hidden');
            }
        }

        function updatePageScroll() {
            //scroll to top of the list
            if ($(window).scrollTop() > $wrapper.offset().top) {
                $("html, body").animate({ scrollTop: $wrapper.offset().top - 180 }, 100);
            }

            //update sticky sidebar
            if (sidebar.length > 0) sidebar.updateSticky();
        }

        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, wrapper, wrapper.onSuccess);

        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPageFailure, wrapper, wrapper.onFailure);

        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPageSuccess, wrapper, wrapper.onSuccessCurrent);

        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPageFailure, wrapper, wrapper.onFailureCurrent);

        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPreviousPageFailure, wrapper, wrapper.onFailure);

        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, wrapper, function (envelope) {
            handleMulitpleAddResult(envelope.message.data.model.data);
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetReplacedByProductsSuccess, wrapper, function (envelope) {
            model = envelope.message.data.data;

            var html = Vendd.Handlebars.parse("productList_A", model);
            var $html = $(html);

            $selectedRelatedPl.closest('.x-replaced-by-products').addClass('initiliazed');

            $selectedRelatedPl.parent().removeClass('x-loading');

            $selectedRelatedPl.html(html);

            Vendd.MessageBus.publish($wrapper, new Vendd.Widget.Messages.BindControl($html));
        });

        Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, wrapper, wrapper.updatePlOnFiltersChange);

    });

    //if global lazyload prices is enabled -> run initLazyLoadPrices
    if (lazyLoadPrices) {
        initLazyLoadPrices();
    } else {
        //if user has custom prices -> run initLazyLoadPrices
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, $pl, function (envelope) {
            customPrices = envelope.message.data.model.HasCustomPrices;
            if (customPrices) initLazyLoadPrices();
        });
    }

    /* Functionality for Lazy Prices & Availabilities */
    function initLazyLoadPrices() {
        var items = [];

        $pl.each(function () {
            var $wrapper = $(this);
            $('.x-product-box[data-variantid]', $wrapper).each(function (i, el) {
                items.push(parseInt($(el).attr('data-variantid')));
            });
        });

        var obj = {
            itemIds: items,
            fetchPrices: true,
            fetchAvailabilities: true,
            fetchStock: true
        };

        Vendd.MessageBus.publishAsync($pl, new Vendd.ScrollList.Messages.GetClientProductListData(obj));
    }

    var LazyPrices = function (obj) {
        $pl.each(function () {
            var $wrapper = $(this);
            var b2bModel = obj.B2B;
            var isB2BUser = b2bModel.IsAuthenticated && b2bModel.IsB2BUser;
            var shouldHidePrices = b2bModel && b2bModel.DisplayOptions && b2bModel.DisplayOptions.ShouldHidePrice;

            $('.x-product-box[data-variantid]:not(.prices-lazyloaded)', $wrapper).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });

                if (itemData.length === 0) {
                    return;
                }

                // hide all
                $('.tag.discount', el).addClass('hide');
                $('.discount-container', el).addClass('hide');
                $('.deleted-price-container', el).addClass('hide');
                $('.current-price-container', el).addClass('hide');
                $('.current-points-price-container', el).addClass('hide');
                $('.current-points-gain-container', el).addClass('hide');

                if (!shouldHidePrices) {
                    var prices = itemData[0].Prices.Price;
                    var points = itemData[0].Prices.Points;
                    var pointsGain = itemData[0].Prices.PointsGain;
                    var countdownPrices = itemData[0].CountDownProperties;
                    var showPriceWithoutVat = prices.ShowPriceWithoutVat;

                    if (prices) {
                        //discount percentage
                        if (countdownPrices && countdownPrices.DiscountPercentage) {
                            $('.tag.discount', el).removeClass('hide');
                            $('.tag.discount', el).text('-' + countdownPrices.DiscountPercentage);
                        } else if (prices.Discount) {
                            $('.tag.discount', el).removeClass('hide');
                            $('.tag.discount', el).text('-' + prices.Discount + '%');
                        }
                        //discount value
                        if (prices.DiscountValue) {
                            $('.discount-container', el).removeClass('hide');
                            $('.discount-value', el).text(decodeEntities(prices.DiscountValue));
                        }
                        
                        //current price
                        var currentPrice;

                        if (countdownPrices) {
                            currentPrice = showPriceWithoutVat ? countdownPrices.PriceWithoutVat : countdownPrices.Price;
                        } else {
                            if (prices.FromPriceText) {
                                currentPrice = showPriceWithoutVat ? prices.FromPriceWithoutVatText : prices.FromPriceText;
                            } else {
                                currentPrice = showPriceWithoutVat ? prices.CurrentPriceWithoutVat : prices.CurrentPrice;
                            }
                        }

                        //deleted price
                        var deletedPrice =
                            prices.DeletedPrice && decodeEntities(showPriceWithoutVat ? prices.DeletedPriceWithoutVat : prices.DeletedPrice)
                            || countdownPrices && decodeEntities(showPriceWithoutVat ? prices.CurrentPriceWithoutVat : prices.CurrentPrice)
                            || undefined;
                        var deletedPriceValue = parseFloat(stringToNumber(deletedPrice));
                        var currentPriceValue = parseFloat(stringToNumber(currentPrice));

                        if (!deletedPriceValue || !currentPriceValue || deletedPriceValue <= currentPriceValue) {
                            deletedPrice = undefined;
                        }

                        if (deletedPrice) {
                            $('.deleted-price-container', el).removeClass('hide');
                            $('.deleted-price', el).text(deletedPrice);
                        } 

                        if ($enableFormatPrices) {
                            $('.current-price', el).html(formatPrice(currentPrice));
                            $('.current-price', el).addClass('price-formatted');
                        } else {
                            $('.current-price', el).text(currentPrice);
                        }
                        $('.current-price-container', el).removeClass('hide');
                    }
                    //points
                    if (points) {
                        $('.current-points-price-container', el).removeClass('hide');
                        $('.current-points-price-container .points-price', el).text(points.PointsPrice);
                    }
                    //points gain
                    if (pointsGain) {
                        $('.current-points-gain-container', el).removeClass('hide');
                        $('.current-points-gain-container .points-gain', el).text(pointsGain.TotalPointsGain);
                    }
                }

                $(el).addClass('prices-lazyloaded');
            });
        });
    };

    var LazyAvailabilities = function (obj) {
        $pl.each(function () {
            var $wrapper = $(this);
            $('.x-product-box[data-variantid]:not(.availabilities-lazyloaded)', $wrapper).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });
                if (itemData.length > 0) {
                    var availability = itemData[0].Availability.AvailabilityData;
                    var cartEnabled = availability.CanBuy === true;
                    $('.availability', $(this)).addClass("availability-" + availability.AvailabilityActionId).text(availability.Name).parent('.availability-container').removeClass('hide');
                    if (cartEnabled) {
                        $('.buttons .add-to-cart', $(this)).removeClass('x-disabled');
                        $('.buttons .add-to-cart button', $(this)).removeAttr('disabled', 'disabled');
                    }
                }

                $(el).addClass('availabilities-lazyloaded');
            });
        });
    };

    $pl.onGetClientProductListDataSuccess = function (envelope) {
        var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
        LazyPrices(result);
        LazyAvailabilities(result);
    };
    $pl.onGetClientProductListDataFailure = function (envelope) {
        //console.log(envelope.message.data);
    };

    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, $pl);
    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataFailure, $pl);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, $pl, $pl.onGetClientProductListDataSuccess);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataFailure, $pl, $pl.onGetClientProductListDataFailure);

    //if infinite scroll and scroll query string
    if (hasInfiniteScroll && hasScrollId)
        scrollToProduct($mainPL);

    //scroll to product on back browser
    function scrollToProduct(mainPL) {

        if (mainPL.length < 1) return;

        var scrollToProductId, productBox, img;

        //get product id from session
        scrollToProductId = sessionStorage.getItem('scrollToProductId');
        //remove product id from session
        sessionStorage.removeItem('scrollToProductId');

        //scroll to product
        productBox = $('.x-product-box[data-productid= ' + scrollToProductId + ']', mainPL);

        if (productBox.length < 1) return;

        img = $('.image-container img:first', productBox).get(0);

        if (img.complete) {
            $('html, body').animate({ scrollTop: productBox.offset().top - 100 }, 0);
        } else {
            waitForImageToLoad(img).then(function () {
                $('html, body').animate({ scrollTop: productBox.offset().top - 100 }, 0);
            });
        }

        function waitForImageToLoad(imageElement) {
            return new Promise(function (resolve, reject) {
                imageElement.onload = resolve;
            });
        }
    };

});

//unload function for browser scroll
window.addEventListener("unload", function () {
    if (sessionStorage.getItem('scrollToProductId')) {
        //disable browser scroll
        history.scrollRestoration = "manual";
    }
});

